// @flow
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import API from "../../api";

import * as ActionTypes from '../../constants/ActionTypes';
import * as Actions from '../../actions/seller/seller.appointments';

function* getStoreAppointmentsSaga(action) {
    try {
        const params = action.payload;
        const queryParams = new URLSearchParams(params).toString();
        const query = queryParams ? `?${queryParams}` : '';
        
        const response = yield API.get(
            `/sellers/appointments${query}`,
            { withCredentials: true }
        );
        
        // The API response structure might be different, let's check both possibilities
        let appointmentData = response.data.data || response.data;
        
        // If the API returns success/data structure, extract the actual data
        if (appointmentData && appointmentData.success && appointmentData.data) {
            appointmentData = appointmentData.data;
        }
        
        yield put(Actions.getStoreAppointmentsSuccess(appointmentData));
    } catch (error) {
        yield put(Actions.getStoreAppointmentsFailure(error));
    }
}

function* confirmAppointmentSaga(action) {
    try {
        const { appointmentId } = action.payload;
        const response = yield API.put(
            `/sellers/appointments/${appointmentId}/confirm`,
            {},
            { withCredentials: true }
        );
        
        // Extract the appointment data correctly
        const appointmentData = response.data?.appointment || response.data?.data || response.data;
        
        yield put(Actions.confirmAppointmentSuccess(appointmentData));
    } catch (error) {
        yield put(Actions.confirmAppointmentFailure(error));
    }
}

function* cancelAppointmentSaga(action) {
    try {
        const { appointmentId, reason } = action.payload;
        const response = yield API.put(
            `/sellers/appointments/${appointmentId}/cancel`,
            { reason },
            { withCredentials: true }
        );
        
        // Extract the appointment data correctly
        const appointmentData = response.data?.appointment || response.data?.data || response.data;
        
        yield put(Actions.cancelAppointmentSuccess(appointmentData));
    } catch (error) {
        yield put(Actions.cancelAppointmentFailure(error));
    }
}

function* getAppointmentDetailsSaga(action) {
    try {
        const { appointmentId, userTimezone } = action.payload;
        const queryParams = `user_timezone=${userTimezone}`;
        
        const response = yield API.get(
            `/sellers/appointments/${appointmentId}?${queryParams}`,
            { withCredentials: true }
        );
        yield put(Actions.getAppointmentDetailsSuccess(response.data.data));
    } catch (error) {
        yield put(Actions.getAppointmentDetailsFailure(error));
    }
}

export default function* SellerAppointmentsSaga() {
    yield takeLatest(ActionTypes.GET_STORE_APPOINTMENTS_REQUEST, getStoreAppointmentsSaga);
    yield takeEvery(ActionTypes.SELLER_CONFIRM_APPOINTMENT_REQUEST, confirmAppointmentSaga);
    yield takeEvery(ActionTypes.SELLER_CANCEL_APPOINTMENT_REQUEST, cancelAppointmentSaga);
    yield takeLatest(ActionTypes.GET_APPOINTMENT_DETAILS_REQUEST, getAppointmentDetailsSaga);
}
